<script lang="ts" setup></script>

<template>
  <m-section
    class="text-text-dark w-full flex-col items-center bg-[linear-gradient(#F0F0F0CC,#F0F0F0CC),url('@/assets/image/contact/pozadina-svetla.png')] bg-cover bg-center bg-no-repeat"
  >
    <div class="max-w-[970px] pb-6 text-center md:pb-12">
      <h2 class="pb-3 text-[32px] leading-[120%] font-semibold">{{ $t("app.homePage.contact.title") }}</h2>
      <p class="leading-[120%] md:text-2xl">
        {{ $t("app.homePage.contact.text") }}
      </p>
    </div>
    <base-button :text="$t('app.base.contactUs')" route-name="ContactPage"></base-button>
  </m-section>
</template>
